import { apiv1A } from '@/api/axios';

export const login = async (encryptedstring) => {
  const res = await apiv1A.get(`/login/${encryptedstring}`);
  return res;
};

export const loginv2 = async (encryptedstring) => {
  // eslint-disable-next-line
  const res = await apiv1A.get(`/loginv2/${encryptedstring}`);
  return res;
};

export const logoutSAAccount = async (state) => {
  const res = await apiv1A.get('/sa/logout', {
    params: {
      sso_state: state,
    },
  });
  return res;
};
export const requestSALogin = async () => {
  const res = await apiv1A.get('/request/login');
  return res;
};
export const feedUserDetails = async (
  codeRec, stateR, codeExpiresIn,
) => {
  const res = await apiv1A.post('auth/login', {
    code: codeRec,
    state: stateR,
    code_expires_in: codeExpiresIn,
  });
  return res;
};
export const isUserAdminCheck = async () => {
  const res = await apiv1A.get('user/isadmin');
  return res;
};
export const isUserManagerCheck = async () => {
  const res = await apiv1A.get('/user/isManager');
  return res;
};
